import { createSlice } from '@reduxjs/toolkit';
import apiClient from 'root/lib/apiClient';
import { Sentry } from 'root/utils/raven';

const initialState = {
  items: {},
  isLoading: false,
  error: null,
};

const categoriesSlice = createSlice({
  name: 'categories',
  initialState,
  reducers: {
    getCategoryStart(state) {
      state.isLoading = true;
    },
    getCategorySuccess(state, { payload: { slug, data } }) {
      state.items[slug] = data;
      state.isLoading = false;
      state.error = null;
    },
    getCategoryFailure(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

export const {
  getCategoryStart,
  getCategorySuccess,
  getCategoryFailure,
} = categoriesSlice.actions;

export default categoriesSlice.reducer;

export const fetchCategory = (permalink) => async (dispatch, getState) => {
  const { categories } = getState();
  if (categories.items[permalink] && !categories.items[permalink]?.length) {
    dispatch(getCategorySuccess({
      slug: permalink,
      data: categories.items[permalink],
    }));
  } else {
    try {
      dispatch(getCategoryStart());
      const { content } = await apiClient({ method: 'GET', url: '/wp-json/mc/v2/router', params: { permalink } });
      dispatch(getCategorySuccess({
        slug: permalink,
        data: content,
      }));
    } catch (e) {
      dispatch(getCategoryFailure(e.toString()));
      Sentry.captureException(e);
    }
  }
};

export const setCategory = ({ slug, data }) => getCategorySuccess({
  slug,
  data,
});
